import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppThunk, RootState} from './store';
import {LatLngLiteral} from '@googlemaps/google-maps-services-js';

type MapAction = ExpandToIncludeClosest | ShowAll | CenterAndZoomToSingle | TrackUserLocation;

interface MapControlState {
    currentAction?: MapAction,
    interactionEnabled: boolean
}

const initialState: MapControlState = {
    currentAction: {type: 'trackUserLocation'},
    interactionEnabled: true 
};

interface ExpandToIncludeClosest {
    type: 'expandToIncludeClosest',
    locations: LatLngLiteral[]
}

interface ShowAll {
    type: 'showAll',
    locations: LatLngLiteral[]
}

interface TrackUserLocation {
    type: 'trackUserLocation',
}

interface CenterAndZoomToSingle {
    type: 'centerAndZoomToSingle',
    location: LatLngLiteral
}

const mapControlSlice = createSlice({
    name: 'mapControl',
    initialState,
    reducers: {
        interactionEnabled: (state) => {
            state.interactionEnabled = true; 
        },
        interactionDisabled: (state) => {
            state.interactionEnabled = false;
        },
        mapActionTriggered: (state, mapAction: PayloadAction<MapAction>) => {
            state.currentAction = mapAction.payload;
        },
        mapActionCompleted: (state) => {
            state.currentAction = undefined;
        },
    },
});

const {
    mapActionTriggered,
    mapActionCompleted: innerMapActionCompleted,
    interactionDisabled,
    interactionEnabled
} = mapControlSlice.actions;

const mapActionCompleted = (): AppThunk => (dispatch, getState) => {
    const currentAction = getCurrentMapActionSelector(getState());
    if (currentAction) {
        dispatch(innerMapActionCompleted());
    }
};

const mapControlReducer = mapControlSlice.reducer;

const getCurrentMapActionSelector: (state: RootState) => MapAction | undefined =
    (state: RootState) => state.mapControl.currentAction;

const getMapInteractionEnabledSelector: (state: RootState) => boolean = (state: RootState) =>
    state.mapControl.interactionEnabled;

export {
    mapControlReducer,
    mapActionCompleted,
    mapActionTriggered,
    getCurrentMapActionSelector,
    interactionDisabled,
    interactionEnabled,
    getMapInteractionEnabledSelector
};
